import React, { useEffect, useState } from 'react';
import { useMusic } from '../../context/MusicContext';
import { BACKEND_URL } from '../../api/backend';
import './InstructionsScreen.css';

const InstructionsScreen = ({ onStart }) => {
  // Control the shared, persistent music player so playback continues after
  // START (this screen unmounts, but the player lives above it).
  const { play: handleStartMusic, pause: handleStopMusic, skip: handleSkipTrack } = useMusic();

  // Live BTC price readout, mirroring the Bit Tanks instructions screen.
  const [btcPrice, setBtcPrice] = useState('Loading...');

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND_URL}/btc_price`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        // The shared backend returns { price }, tanks' own server { btc_price }
        const price = data && (data.btc_price ?? data.price);
        if (typeof price === 'number') {
          setBtcPrice(
            new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(price)
          );
        } else {
          setBtcPrice('Unavailable');
        }
      })
      .catch(() => {
        if (!cancelled) setBtcPrice('Unavailable');
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <div id="instructionsScreen" role="dialog" aria-labelledby="gameTitle" aria-modal="true">
      <div className="instruction-card">
        <button
          type="button"
          className="instruction-close"
          onClick={onStart}
          aria-label="Close instructions"
        >
          ✕
        </button>
        <h1 id="gameTitle"><span className="gameTitle__42">42</span> Bit Wheel</h1>

        <div className="btc-readout" aria-live="polite">
          <span className="btc-value">{btcPrice}</span>
          <span className="btc-label">Today's BTC Price</span>
        </div>

        <ul className="instruction-list">
          <li>
            <span className="highlight-number">1.</span> Spin the wheel to <span className="highlight-green">win points</span>
          </li>
          <li>
            <span className="highlight-number">2.</span> Guess the correct <span className="highlight-blue">color</span> or <span className="highlight-orange">number</span> to multiply winnings
          </li>
          <li>
            <span className="highlight-number">3.</span> Select <span className="highlight-red">wager</span> to multiply winnings further, or save spin points by wagering <span className="highlight-green">0</span>
          </li>
          <li>
            <span className="highlight-number">4.</span> Compete for a spot on the <span className="highlight-blue">leaderboard</span>
          </li>
        </ul>

        <button id="startButton" onClick={onStart}>SPIN NOW!</button>

        <div id="startScreenAudio" className="instruction-audio">
          <div className="audio-controls">
            <button
              className="audio-button"
              onClick={handleStartMusic}
              aria-label="Start music"
              title="Swipe right or click to start music"
            >
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </button>

            <button
              className="audio-button"
              onClick={handleSkipTrack}
              aria-label="Skip track"
              title="Skip to next track"
            >
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 4l10 8-10 8V4zm12 0v16h2V4h-2z"/>
              </svg>
            </button>

            <button
              className="audio-button"
              onClick={handleStopMusic}
              aria-label="Stop music"
              title="Swipe left or click to stop music"
            >
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="6" width="12" height="12"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructionsScreen;
